document.addEventListener('DOMContentLoaded', function() {
  const sizeGuideSection = document.querySelector('.size-guide-container');
  const modalContent = sizeGuideSection.querySelector('.modal-content');

  // Use event delegation so clicks still work after variant re-renders replace the toggle DOM nodes
  document.addEventListener('click', function(event) {
    if (event.target.closest('.size-guide-toggle')) {
      sizeGuideSection.classList.toggle('active');
    }
  });

  sizeGuideSection.addEventListener('click', function(event) {
    if (modalContent && !modalContent.contains(event.target)) {
      sizeGuideSection.classList.remove('active');
    }
  });
});